import React, { createContext, useContext, useEffect, useState } from "react";
import { apiGet, apiPost } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=admin
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ec_token");
    if (!token) {
      setUser(false);
      setChecking(false);
      return;
    }
    apiGet("/auth/me")
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("ec_token");
        setUser(false);
      })
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const res = await apiPost("/auth/login", { email, password });
    if (!res.success) throw new Error(res.error?.message || "Login failed");
    localStorage.setItem("ec_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("ec_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, checking, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
